'use client';

import { getSession, signIn } from 'next-auth/react';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { useTeams } from '../../lib/hooks/useTeams';
import { useInitLocalizationAndSiteSettings } from '../../lib/router/useInitLocalizationAndSiteSettings';
import { useRouter } from '../../lib/routing/routing';
import { PageProps } from '../../lib/sanity/types';
import { SignInForm } from './SignInForm';

export const SignInPageContent = (props: PageProps) => {
	useInitLocalizationAndSiteSettings(props);

	const searchParams = useSearchParams();

	const router = useRouter();
	const { isTeams, authentication } = useTeams();
	const [inProgress, setInProgress] = useState(true);
	const callbackUrl = searchParams?.get('callbackUrl') || '/';

	useEffect(() => {
		getSession().then((session) => {
			if (session) {
				return router.replace(callbackUrl);
			}
			setInProgress(false);
		});
	}, [callbackUrl, router]);

	const submit = async () => {
		try {
			setInProgress(true);

			if (isTeams) {
				// @ts-expect-error
				authentication
					.authenticate({
						url: window.location.origin + '/auth/popup/',
						width: 600,
						height: 535,
					})
					.then(() => router.replace(callbackUrl))
					.catch(() => router.refresh());
			} else if (window.location !== window.parent.location) {
				window.open(window.location.origin + '/auth/popup/', '', 'height=600px,width=535px');
			} else {
				await signIn('azure-ad', { callbackUrl });
			}
		} catch {
			setInProgress(false);
		}
	};

	return <SignInForm inProgress={inProgress} onSubmit={submit} />;
};
